module.exports = __webpack_public_path__ + "img/wygg.ab3f7f57.svg";